import { AfterViewInit, Component, Input, OnInit, OnDestroy, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import {TranslateService} from '@ngx-translate/core';
import { ModalService } from 'src/app/common/modal/modal.service';
import { APP_Constants } from 'src/app/app.constant';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { GenericModalV2Component } from '../generic-modal-v2/generic-modal-v2.component';
declare var H: any;
@Component({
    selector: 'app-header-info',
    templateUrl: './header-info.component.html',
    styleUrls: ['./header-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderInfoComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(  private matDialog: MatDialog,private appService: AppService,public translate: TranslateService) { }
  @Input() configData;
  @Input() headerInfo;
   warningDlg: MatDialogRef<GenericModalV2Component>;
  @ViewChild('trackingMap') trackingMap!: TemplateRef<any>;
  className:any;
  mode: String = 'indeterminate';
  color: String = 'primary';
  isLoading: boolean = false;
  typeText:any;
  iconDetails:any;
  statuswithspace:any;
  ngOnInit(): void {
    this.statuswithspace =  this.appService.separatePascalCase(this.headerInfo.Status);
    this.setOrderStatusIconCss();
  }
@ViewChild('trackingMap') trackingMapTemplate!: TemplateRef<any>;
  hereMapId;
  hereMapCode;
  startPoint; 
  endPoint;
  currentTruckLocation: any;
  mapConfig;
  consigneeAddress; 
  templateData;
  startLabelData;
  endLabelData;

  formatAddressForLabel(address: any) {
    return `
    ${address?.line1 || ''}<br>
    ${address?.city || ''}${address?.region ? ', ' + address.region : ''}${address?.zip ? ', ' + address.zip : ''}<br>
    ${address?.country || ''}
  `;
  }


openTrackingModal(): void {
  this.isLoading = true;
  const customerCode = localStorage.getItem('customerCode');
  const userName = localStorage.getItem('userName');

  const templateUrl = `${APP_Constants.COX_UPDATE_ORDER_V2_TEMPLATE}${customerCode}&userId=${userName}`;

  if (this.appService.templateRequestInfoStore.has(templateUrl)) {
    this.templateData = this.appService.templateRequestInfoStore.get(templateUrl);
    const deepData = JSON.parse(JSON.stringify(this.templateData));
    this.appService.templateRequestInfoStore.set(templateUrl, deepData);
    this.hereMapId = this.templateData?.hereMapId;
    this.hereMapCode = this.templateData?.hereMapCode;
    this.mapConfig = this.templateData?.mapConfig;
  }

  document.getElementById("overlay").style.display = "block";

  const url = `${APP_Constants.ORDER_TRACK_AND_TRACE}&userId=${encodeURIComponent(userName)}`;

  const businnessObjIds = JSON.parse(sessionStorage.getItem('businnessObjIds') || '[]');

  const payload = {
    orderId: businnessObjIds?.[0]
  };

  this.appService.makeHttpPostRequest(url, payload).subscribe({

    next: (v: any) => {

      const order = v?.data?.trackAndTraceOrder?.orderDetails;
      const consignee = order?.consigneeAddress;
      const consignor = order?.consignorAddress;

      this.startLabelData = this.formatAddressForLabel(consignee);
      this.endLabelData = this.formatAddressForLabel(consignor);

      const driverEvent = order?.events?.find((e: any) => e?.location);

      if (driverEvent?.location) {
        this.currentTruckLocation = {
          lat: +driverEvent.location.latitude,
          lng: +driverEvent.location.longitude,
          updatedAt: driverEvent.issuedDateUtc
        };
      }

      this.startPoint = {
        query: `${consignee?.line1},${consignee?.city},${consignee?.region},${consignee?.zip},${consignee?.country}`
      };

      this.endPoint = {
        query: `${consignor?.line1},${consignor?.city},${consignor?.region},${consignor?.zip},${consignor?.country}`
      };

      this.openMapModal();
    },

    error: () => {
  this.isLoading = false;
  const overlay = document.getElementById("overlay");
  if (overlay) overlay.style.display = "none";

  let errorModal = {
    actions: true,
    type: 'confirm',
    name: "noMap",
    title: "Map Tracking Unavailable",
    description: "Location currently not available. Please try again later.",
    noCancelButton: true,
    actionButtonText: "OK",
    imgIcon: '../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1350,24,24))',
    style: { width: "600px", height: "200px" }
  };

  let modalConfig: MatDialogConfig<any> = new ModalConfig(errorModal);

  this.warningDlg = this.matDialog.open(GenericModalV2Component, modalConfig);

  const subject = new Subject<boolean>();
  this.warningDlg.componentInstance.subject = subject;

  this.warningDlg.afterClosed().subscribe(() => {});

}

  });

}
      

  
  isPickedUp(){
    if(this.configData?.mapLink?.visibleForStatus?.indexOf(this.headerInfo.Status) !== -1){
      return true;
    }else{
      return false;
    }
  }
  openMapModal() {
    this.isLoading = false;
    const subject = new Subject<boolean>();

    let config = {
      actionButtonText: "Close",
      heading: "Track My Shipment",
      actions: true,
      name: "trackShipmentMap",
      title: "Track My Shipment",
      data: {
        hereMapId: this.hereMapId,
        hereMapCode: this.hereMapCode,
        mapOptions: {
          start: this.startPoint,
          finish: this.endPoint
        },
        mapConfig: this.mapConfig,
        currentTruckLocation: this.currentTruckLocation,
        startLabelData: this.startLabelData,
        endLabelData: this.endLabelData
      },
      style: { width: "70%", height: "575px" }
    };

    let modalConfig: MatDialogConfig<any> = new ModalConfig(config);

    const dialogRef = this.matDialog.open(
      GenericModalV2Component,
      modalConfig
    );

    dialogRef.componentInstance.subject = subject;

    dialogRef.afterClosed().subscribe(() => {
      document.getElementById("overlay").style.display = "none";
    });

  return subject.asObservable();
}
  setOrderStatusIconCss() {
     
    if (this.configData.orderStatus['iconText'] && this.configData.orderStatus['iconText'].includes(this.headerInfo.Status)) {
      this.typeText = this.headerInfo.Status ? this.headerInfo.Status.substring(0, this.configData.orderStatus['iconTextChars']) : '';
    }
    else {
      this.typeText = this.headerInfo.Status ? this.headerInfo.Status.charAt(0) : '';
    }
    if (this.configData.orderStatus.statusSucessBorder && this.configData.orderStatus.statusSucessBorder.includes(this.headerInfo.Status)) {
      this.className = 'dhl-type-' + this.typeText + '-green-bordered-v2';
    } else if (this.configData.orderStatus.statusFailedBorder && this.configData.orderStatus.statusFailedBorder.includes(this.headerInfo.Status)) {
      this.className = 'dhl-type-' + this.typeText + '-bordered-v2';
    } else {
      this.className = 'dhl-type-' + this.typeText + '-v2';
      if (this.headerInfo.Status.toLowerCase() == "delivered") {
        this.className = 'dhl-type-' + "Del" + '-v2';
      }
    }
    if (this.headerInfo.Status == "VerificationOnHold" || this.headerInfo.Status == "EnrichmentOnHold" || this.headerInfo.Status == "OnHold") {
      this.className = 'dhl-type-' + this.typeText + '-DottedLine';
    }
    if (this.headerInfo.Status.toLowerCase() == "deliveryconfirmed") {
      this.className = 'dhl-ptype-' + "DelCon" + '-v3';
    }
    if (this.headerInfo.Status.toLowerCase() == "pendingacceptance") {
      this.className = 'dhl-ptype-' + "PA" + '-v3';
    }
    if (this.headerInfo.Status.toLowerCase() == "planningfailed") {
      this.className = 'dhl-type-PF-bordered-v2';
    }
    if (this.headerInfo.Status.toLowerCase() == "intransit") {
      this.className = 'dhl-ptype-' + "IT" + '-v3';
    }
    if (this.headerInfo.Status.toLowerCase() == "dispatched") {
      this.className = 'dhl-type-DISP-bordered-v2';
    }
    if (this.headerInfo.Status == "ShipmentNotStarted") {
      this.className = 'dhl-type-sns-bordered-v2';
    }
    if (this.headerInfo.Status === "PlanningFailed" || this.headerInfo.Status === "DeliveryConfirmed" || this.headerInfo.Status === "PendingAcceptance" || this.headerInfo.Status === "InTransit"  || this.headerInfo.Status === "ShipmentNotStarted") {
      this.typeText = this.headerInfo.Status.match(/[A-Z]/g)?.join('') || '';
    } else if (this.headerInfo.Status === "Dispatched") {
      this.typeText = this.headerInfo.Status.substring(0, 4).toUpperCase();;
    }
  }
  ngAfterViewInit(){}

  ngOnDestroy() {}
}
